import { AxisPreferences } from '../../config/plotTypes';

// -- helper functions --

/**
 * Builds the two-character label shown in the axis management avatar circle.
 *
 * X axes always render as `X`, regardless of their internal axis key.
 * Y axes keep the legacy behavior of using the first two characters of the key.
 *
 * @param axisKey - Internal axis key.
 * @param prefs - Axis preferences for the row being rendered.
 * @returns Uppercase avatar label, at most two characters long.
 */
export function getAxisAvatarLabel(
  axisKey: string,
  prefs: AxisPreferences
): string {
  if (prefs.isXAxis) {
    return 'X';
  }

  return axisKey.slice(0, 2).toUpperCase();
}
